/* Add following line above global.js line at theme.liquid */
/* <script src="{{ 'iwm.js' | asset_url }}" defer="defer"></script> */

// Weiterleitung nur nach Double-Opt-In Bestätigung
if (window.location.pathname.includes('/account/subscribe') && window.location.search.includes('token=')) {
    window.location.replace('/pages/newsletter');
}